import { useFetch } from "~vue/api";
import AmplitudeEventNames from "~vue/utils/amplitudeEventNames";
import { logUserInteraction } from "~vue/utils/logUtils";
import { ref } from "vue";

/** Saves whether the user reviews other team members this moment. The page owns the prop this changes, so refreshing it is the caller's job. */
export function useHasPeopleToReviewToggle() {
    const payload = ref({ has_people_to_review: false });
    const { execute, error } = useFetch("/api/coach/performance_reviews/user_data/", { immediate: false }).post(payload).json();

    /** Resolves false when the save failed, so the caller can surface its own error; on true the caller refreshes its data. */
    const setHasPeopleToReview = async (hasPeopleToReview: boolean, momentId: string | number | null): Promise<boolean> => {
        payload.value = { has_people_to_review: hasPeopleToReview };
        await execute();
        if (error.value) {
            return false;
        }

        void logUserInteraction(AmplitudeEventNames.PERFORMANCE_REVIEW_HAS_PEOPLE_TO_REVIEW_SELECTED, { has_people_to_review: hasPeopleToReview, moment_id: momentId });
        return true;
    };

    return { setHasPeopleToReview };
}
